var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Neewerai-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["moduleName"],
                              expression: "['moduleName']",
                            },
                          ],
                          staticStyle: { width: "180px" },
                          attrs: { placeholder: "请选择模块类型" },
                        },
                        _vm._l(_vm.moduleNameMap, function (el) {
                          return _c(
                            "a-select-option",
                            { key: el.value, attrs: { value: el.value } },
                            [_vm._v(_vm._s(el.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["versionNumber"],
                            expression: "['versionNumber']",
                          },
                        ],
                        staticStyle: {
                          width: "200px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: { placeholder: "请输入版本号" },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "moduleNameSlot",
              fn: function (record) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.moduleNameMap.find(
                          (e) => e.value === record.moduleName
                        )?.label || record.moduleName
                      ) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "versionDate",
              fn: function (record) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dataFormatStr(record.versionDate, "YYYY-MM-DD")
                      ) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "createTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.createTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "updateTime",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.dataFormatStr(record.updateTime)) + " "
                  ),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "800px",
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Neewerai-version_ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 7 },
                "wrapper-col": { span: 14 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "模块类型", prop: "moduleName" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择模块类型" },
                      model: {
                        value: _vm.ruleForm.moduleName,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "moduleName", $$v)
                        },
                        expression: "ruleForm.moduleName",
                      },
                    },
                    _vm._l(_vm.moduleNameMap, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.value, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本号", prop: "versionNumber" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入版本号",
                      "max-length": 64,
                    },
                    model: {
                      value: _vm.ruleForm.versionNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionNumber", $$v)
                      },
                      expression: "ruleForm.versionNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本日期", prop: "versionDate" } },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { format: _vm.dateFormat },
                    model: {
                      value: _vm.ruleForm.versionDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionDate", $$v)
                      },
                      expression: "ruleForm.versionDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "版本更新内容",
                    prop: "versionUpdateContent",
                  },
                },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入版本更新内容",
                      rows: 4,
                      maxLength: 2048,
                    },
                    model: {
                      value: _vm.ruleForm.versionUpdateContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionUpdateContent", $$v)
                      },
                      expression: "ruleForm.versionUpdateContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "版本更新详细说明（富文本）",
                    prop: "versionUpdateDetailContent",
                  },
                },
                [
                  _vm.visible
                    ? _c("edit-components", {
                        attrs: {
                          content: _vm.ruleForm.versionUpdateDetailContent,
                          "html-change": _vm.onVersionUpdateDetailContentChange,
                          uploadImg: _vm.uploadRichTextImg,
                          "upload-path": _vm.richTextUploadPath,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }